import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

// import { showColorPicker, setColor } from "../lfcStore/color/colorSlice";
// For MOK, colorSlice is moved to lfcSlice in MOK store
import { showColorPicker, setColor } from '../../../../store/lfc/lfcSlice'
// import { setConfigString } from "../lfcStore/addToCart/addToCartSlice";

import Tooltip from './Tooltip/Tooltip'
import Thumbnail from './Thumbnail/Thumbnail'
import SelectBox from './SelectBox/SelectBox'

class DimensionSelect extends React.Component {
  constructor(props) {
    super(props)

    // Props instead of local state /MOK
    // this.state = {
    //   selectedValue: this.props.selectedValue || this.props.values[0].valueId,
    //   correctionInformation: this.props.correctionInformation,
    // };

    if (!this.props.selectedValue) {
      this.props.onChange(this.props.values[0].valueId, null)
    }

    this.checkIfCheckboxIsDisabled = this.checkIfCheckboxIsDisabled.bind(this)
    this.findValueForOptionYes = this.findValueForOptionYes.bind(this)
    this.getValueIdForOptionYes = this.getValueIdForOptionYes.bind(this)
    this.handleCheckbox = this.handleCheckbox.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.renderCorrectionInformationContainer = this.renderCorrectionInformationContainer.bind(this)
    this.renderCorrectionInformation = this.renderCorrectionInformation.bind(this)
  }

  // Props instead of local state /MOK
  // UNSAFE_componentWillReceiveProps(nextProps) {
  //   if (nextProps !== this.props) {
  //     this.setState({
  //       selectedValue:
  //         nextProps.selectedValue ||
  //         (nextProps.values[0].valueId &&
  //           nextProps.onChange(nextProps.values[0].valueId, null)),
  //       correctionInformation: nextProps.correctionInformation,
  //     });
  //   }
  // }

  checkIfCheckboxIsDisabled() {
    const foundValue = this.findValueForOptionYes()

    if (foundValue) {
      return !foundValue.selectable
    } else {
      return true
    }
  }

  findValueForOptionYes() {
    const foundValue = this.props.values.find((value) => this.props.getValueCode(value.valueId) === 'yes')

    return foundValue
  }

  getValueIdForOptionYes() {
    const foundValue = this.findValueForOptionYes()

    if (foundValue) {
      return foundValue.valueId
    } else {
      return null
    }
  }

  handleCheckbox() {
    // let prevSelectedValue = null;

    // this.setState(
    //   (prevState) => {
    //     prevSelectedValue = prevState.selectedValue;

    //     const selectedValue = this.props.values.find(
    //       (value) => value.valueId !== prevSelectedValue
    //     ).valueId;

    //     return {
    //       selectedValue,
    //     };
    //   },
    //   () => {
    //     this.props.onChange(this.state.selectedValue, prevSelectedValue);
    //   }
    // );
    // Props instead of local state /MOK
    const prevSelectedValue = this.props.selectedValue || this.props.values[0].valueId

    const selectedValue = this.props.values.find((value) => value.valueId !== prevSelectedValue).valueId

    this.props.onChange(selectedValue, prevSelectedValue)
  }

  handleSelect(event) {
    const { value } = event.target
    let prevSelectedValue = null

    // this.setState(
    //   (prevState) => {
    //     if (prevState.selectedValue !== "noneSelected") {
    //       // TODO--LFC ta bort denna check, onödigt nu?
    //       prevSelectedValue = parseInt(prevState.selectedValue, 10);
    //     }

    //     return {
    //       selectedValue: value,
    //     };
    //   },
    //   () => {
    //     this.props.onChange(
    //       parseInt(this.state.selectedValue, 10),
    //       prevSelectedValue
    //     );
    //   }
    // );
    // Props instead of local state /MOK
    if (this.props.selectedValue !== 'noneSelected' && this.props.values[0].valueId !== 'noneSelected') {
      // TODO--LFC: ta bort denna check, onödigt nu?
      prevSelectedValue = parseInt(this.props.selectedValue || this.props.values[0].valueId, 10)
    }

    this.props.onChange(parseInt(value, 10), prevSelectedValue)
  }

  // TODO--LFC, behöver refaktoreras. 'value' ska alltid skickas tillbaka? Slå ihop med handleSelect() /MOK
  handleClick(event, color) {
    const { value } = event.target
    let prevSelectedValue = null

    // this.setState(
    //   (prevState) => {
    //     if (prevState.selectedValue !== "noneSelected") {
    //       // TODO--LFC ta bort denna check, onödigt nu?
    //       prevSelectedValue = parseInt(prevState.selectedValue, 10);
    //     }

    //     return {
    //       selectedValue: value,
    //     };
    //   },
    //   () => {
    //     if (color) {
    //       /*
    //         Not used for MOK
    //       */
    //       // if (
    //       //   this.props.dimensionCode === "dorColor" ||
    //       //   this.props.dimensionCode === "wdwColor"
    //       // ) {
    //       //   this.props.showColorPicker(color === "OPTIONAL_COLOR");
    //       // }
    //       this.props.setColor(color);
    //     }

    //     this.props.onChange(
    //       parseInt(this.state.selectedValue, 10),
    //       prevSelectedValue
    //     );
    //   }
    // );
    // Props instead of local state /MOK
    if (this.props.selectedValue !== 'noneSelected' && this.props.values[0].valueId !== 'noneSelected') {
      // TODO--LFC: ta bort denna check, onödigt nu?
      prevSelectedValue = parseInt(this.props.selectedValue || this.props.values[0].valueId, 10)
    }

    if (color) {
      /*
               Not used for MOK
           */
      // if (
      //   this.props.dimensionCode === "dorColor" ||
      //   this.props.dimensionCode === "wdwColor"
      // ) {
      //   this.props.showColorPicker(color === "OPTIONAL_COLOR");
      // }
      this.props.setColor(color)
    }

    this.props.onChange(parseInt(value, 10), prevSelectedValue)
  }

  renderCorrectionInformationContainer(message) {
    return <Tooltip content={message} dataId="correction-information" openFromStart={true} />
  }

  renderCorrectionInformation() {
    const { constraint } = this.props.correctionInformation
    const messages = this.props.messages.correctionInformation

    if (constraint.checkStatus === 'DENYFOR') {
      if (constraint.decisionConditions[0].type === 'SINGLE') {
        return this.renderCorrectionInformationContainer(
          `${messages.notAbleToSelect} ${this.props.getDimensionName(
            constraint.valueId
          )} ${this.props.getValueName(constraint.valueId)} ${
            messages.becauseYouHaveSelected
          } ${this.props.getDimensionName(
            constraint.decisionConditions[0].valueId
          )} ${this.props.getValueName(constraint.decisionConditions[0].valueId)}.`
        )
        // TODO--LFC TESTA NEDAN (DENYFOR med AND)
      }
      if (constraint.decisionConditions[0].type === 'AND') {
        const nameObjects = constraint.decisionConditions[0].valueIdList.forEach((valueId) => ({
          dimensionName: this.props.getDimensionName(valueId),
          valueName: this.props.getValueName(valueId),
        }))
        let namesString = ''
        nameObjects.forEach((nameObject) => {
          namesString += `${nameObject.dimensionName} ${nameObject.valueName}`
          if (nameObjects.indexOf(nameObject) === nameObjects.length - 2) {
            namesString += ` ${messages.and} `
          } else if (nameObjects.indexOf(nameObject) !== nameObjects.length - 1) {
            namesString += ', '
          }
        })
        return this.renderCorrectionInformationContainer(
          `${messages.notAbleToSelect} ${this.props.getDimensionName(
            constraint.valueId
          )} ${this.props.getValueName(constraint.valueId)} ${messages.becauseYouHaveSelected} ${namesString}.`
        )
      }
    }

    if (constraint.checkStatus === 'NEEDSANYOF') {
      const strings = constraint.decisionConditions.map((condition) => {
        if (condition.type === 'SINGLE') {
          return `${this.props.getDimensionName(condition.valueId)} ${this.props.getValueName(condition.valueId)}`
        }
        if (condition.type === 'AND') {
          let string = ''
          condition.valueIdList.forEach((valueId) => {
            string += `${this.props.getDimensionName(valueId)} ${this.props.getValueName(valueId)}`
            if (condition.valueIdList.indexOf(valueId) === condition.valueIdList.length - 2) {
              string += ` ${messages.and} `
            } else if (condition.valueIdList.indexOf(valueId) !== condition.valueIdList.length - 1) {
              string += ', '
            }
          })
          return string
        }
        // shall never occur
        return ''
      })
      let stringToDisplay = ''
      strings.forEach((string) => {
        stringToDisplay += string
        if (strings.indexOf(string) === strings.length - 2) {
          stringToDisplay += ` ${messages.or} `
        } else if (strings.indexOf(string) !== strings.length - 1) {
          stringToDisplay += ', '
        }
      })
      return this.renderCorrectionInformationContainer(
        `${messages.notAbleToSelect} ${this.props.getDimensionName(
          constraint.valueId
        )} ${this.props.getValueName(constraint.valueId)}, ${messages.youNeedToSelect} ${stringToDisplay}.`
      )
    }

    // shall never occur
    return null
  }

  render() {
    // if simple OPTION dimension, render checkbox
    // (currently not rendering dimension description, TODO)
    if (this.props.type === 'OPTION' && this.props.values.length === 2) {
      return (
        <div className="lfc-checkbox-container">
          <input
            type="checkbox"
            id={this.props.id}
            name={this.props.id}
            disabled={this.checkIfCheckboxIsDisabled()}
            // checked={this.state.selectedValue === this.getValueIdForOptionYes()}
            // Props instead of local state /MOK
            checked={
              this.props.selectedValue === this.getValueIdForOptionYes() ||
              this.props.values[0].valueId === this.getValueIdForOptionYes()
            }
            onChange={this.handleCheckbox}
          />

          <label htmlFor={this.props.id}>
            {this.props.getValueName(this.getValueIdForOptionYes(), this.props.language)}
          </label>

          {/* {this.state.correctionInformation &&
            this.renderCorrectionInformation()} */}
          {/* Props instead of local state /MOK */}
          {this.props.correctionInformation && this.renderCorrectionInformation()}
        </div>
      )
    }

    // if simple OPTION dimension, render checkbox
    // (currently not rendering dimension description, TODO)
    if (this.props.type === 'THUMBNAIL') {
      return (
        <Thumbnail
          id={this.props.id}
          dimensionCode={this.props.dimensionCode}
          name={this.props.name}
          description={this.props.description}
          // selectedValue={this.state.selectedValue.toString()}
          // Props instead of local state /MOK
          selectedValue={
            this.props.selectedValue ? this.props.selectedValue.toString() : this.props.values[0].valueId.toString()
          }
          values={this.props.values}
          variant={this.props.variant}
          handleClick={this.handleClick}
          language={this.props.language}
          // renderCorrectionInformation={
          //   this.state.correctionInformation
          //     ? this.renderCorrectionInformation
          //     : null
          // Props instead of local state /MOK
          renderCorrectionInformation={this.props.correctionInformation ? this.renderCorrectionInformation : null}
        />
      )
    }

    // else if STANDARD dimension or multi OPTION dimension
    return (
      <SelectBox
        id={this.props.id}
        name={this.props.name}
        description={this.props.description}
        // selectedValue={this.state.selectedValue.toString()}
        // Props instead of local state /MOK
        selectedValue={
          this.props.selectedValue ? this.props.selectedValue.toString() : this.props.values[0].valueId.toString()
        }
        handleSelect={this.handleSelect}
        values={this.props.values}
        language={this.props.language}
        // renderCorrectionInformation={
        //   this.state.correctionInformation
        //     ? this.renderCorrectionInformation
        //     : null
        // Props instead of local state /MOK
        renderCorrectionInformation={this.props.correctionInformation ? this.renderCorrectionInformation : null}
      />
    )
  }
}

DimensionSelect.defaultProps = {
  variant: null,
  selectedValue: null,
  correctionInformation: null,
}

DimensionSelect.propTypes = {
  variant: PropTypes.string,
  correctionInformation: PropTypes.shape({
    dimensionId: PropTypes.number,
    constraint: PropTypes.object,
  }),
  description: PropTypes.string,
  getDimensionName: PropTypes.func.isRequired,
  getValueCode: PropTypes.func.isRequired,
  getValueName: PropTypes.func.isRequired,
  showColorPicker: PropTypes.func,
  setColor: PropTypes.func,
  color: PropTypes.string,
  id: PropTypes.string.isRequired,
  dimensionCode: PropTypes.string,
  language: PropTypes.oneOf(['SE', 'NO', 'FI', 'EN']).isRequired,
  messages: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selectedValue: PropTypes.number,
  type: PropTypes.string,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      cgeValueCode: PropTypes.string,
      defaultSortOrder: PropTypes.number,
      dimensionId: PropTypes.number.isRequired,
      factoryValueCode: PropTypes.string,
      mathValue: PropTypes.number,
      selectable: PropTypes.bool,
      valueCode: PropTypes.string,
      valueId: PropTypes.number.isRequired,
      valueNameEN: PropTypes.string,
      valueNameFI: PropTypes.string,
      valueNameNO: PropTypes.string,
      valueNameSE: PropTypes.string,
    })
  ),
}

const mapStateToProps = (state) => ({
  // Moved to state.lfc for MOK
  showColorPicker: state.lfc.color.colorPickerVisible,
  // Moved to state.lfc for MOK
  color: state.lfc.color.color,
  // configString: state.addToCart.configString, // används aldrig, MOK
})

const mapDispatchToProps = {
  showColorPicker,
  setColor,
  // setConfigString, // används aldrig, MOK
}

export default connect(mapStateToProps, mapDispatchToProps)(DimensionSelect)
